import baseTheme from "@/themes/baseTheme";
import { ThemeConfig } from "antd";

const stageTheme: ThemeConfig = {
  ...baseTheme,
  token: {
    ...baseTheme.token,
    colorBgLayout: "#CAE4F1",
  },
};

export default stageTheme;
